'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isDocumentNode = exports.isText = exports.isAttribute = exports.isElement = undefined;

var _ramda = require('ramda');

var _constants = require('./shared/constants');

// String -> Node -> Boolean
var nodeTypeTest = (0, _ramda.propEq)(_constants.NODE_TYPE);

var isElement = nodeTypeTest(_constants.ELEMENT_NODE);
var isText = nodeTypeTest(_constants.TEXT_NODE);
var isAttribute = nodeTypeTest(_constants.ATTRIBUTE_NODE);
var isDocumentNode = nodeTypeTest(_constants.DOCUMENT_NODE);

exports.isElement = isElement;
exports.isAttribute = isAttribute;
exports.isText = isText;
exports.isDocumentNode = isDocumentNode;